export const memberTermsOfUseJa = `
ＦＣＳネット会員規約

（ネットワーク利用に限定）

第１条（本規約の範囲及び変更）
１．本規約は、エフシースタンダードロジックス株式会社（以下、「弊社」）が提供する、第２条 第１項に定義したＦＣＳネットサービスに関し、会員の利用及び加入条件を規定したものです。
２．弊社は、会員の承諾なしに、ＦＣＳネットサービスを通じてあるいはその他の方法で掲示することにより本規約を変更することができるものとします。
３．ＦＣＳネットサービスの各サービス毎に提示される運用規定及び弊社がオンラインあるいはその他の方法により随時提示するその他の諸規定は、本規約の一部を構成するものとします。各運用規定又は諸規定が本規約と異なっている場合には、各運用規定又は諸規定が優先するものとします。

第２条（定義） 
１．「ＦＣＳネットサービス」とは、弊社が主催する会員制によるWEBブッキング＆トレースサービスをいいます。 
２．会員」とは、本規約にご同意いただいた上で、弊社が指定する手続きに従って、ＦＣＳネットサービスへの加入申込を行い、かつ弊社がそれを承諾することにより、弊社との間で会員契約が締結された方をいいます。

第３条（提供するサービス） 
１．ＦＣＳネットサービスは、以下のサービスで構成されています。
(1)貨物輸送のWEBブッキング
(2)情報提供サービス 
２．前項の規定にかかわらず、ＦＣＳネットサービスの内容は、その時点で合理的に提供可能なものとします。 
３．ＦＣＳネットサービスの提供区域は、日本国内とします。
４．ＦＣＳネットのサービスの最低利用期間は、１ヶ月とします。

第４条（ＦＣＳネットサービスの利用が認められる方）
ＦＣＳネットサービスは、会員のみが利用することができるものとします。会員は、上記に従ってＦＣＳネットサービスを利用することが認められる方以外の第三者に、ＦＣＳネットサービスを利用させないようにしなければならないものとします。

第５条（会員契約の申込）
ＦＣＳネットの会員契約の申込は、弊社が別途指定する方法によるものとします。

第６条（承諾）
弊社が、前条の申込を受けたときはこれを承諾するものとします。弊社が承諾を行った時点で、会員契約が成立します。但し、申込を行った方が以下の各号のいずれかに該当している場合は、申込を承諾しない場合があります。また、弊社が申込を承諾した後であっても、会員が以下の各号のいずれかに該当していることが判明した場合は、会員契約を解除し、会員資格を取り消すことがあります。
(1)過去に会員規約違反等により、ＦＣＳネットサービスの会員資格を取り消されたことがある場合。
(2)申込内容に虚偽、記入漏れ、誤記がある場合。
(3)その他弊社が会員として不適切と判断した場合。

第７条（登録内容の変更）
会員は、会員の登録内容に変更が生じた場合は、弊社が別途指定する方法により、速やかに届出をしなければならないものとします。

第８条（会員ユーザーID及びパスワード） 
１．弊社は、会員登録の申込を行う方のユーザーID及びパスワードをＦＣＳネットを通 じて登録するものとし、これにより本規約に従って会員契約が締結されるものとします。オンラインサインアップ以外の方法によって、会員契約の申込を行った方に対しては、原則として、本規約に従って会員契約が締結され、弊社における会員登録の手続きが完了した後に、ユーザーID及びパスワードを通 知するものとします。 
２．会員は、弊社によって登録されるユーザーID及びパスワードを自己の責任で管理するものとし、第三者に貸与・譲渡しないものとします。第三者が会員のユーザーID及びパスワードを不正に使用したことにより損害が生じた場合は、弊社は、一切責任を負いません。 
３．会員は、ユーザーID及びパスワードを忘れた場合や盗用された場合は、速やかに弊社に連絡するものとします。

第９条（料金等） 
１．会員は、ＦＣＳネットサービスのご利用は原則的に無料とします。ただし、今後新たなサービスの展開をする場合、そのサービスの内容によっては、またそのサービスに限定しての料金を定めることとします。 
２．弊社は、会員の承諾なく、前項の料金を決定することができるものとします。 その場合、弊社は、その旨をＦＣＳネットサービスを通じて掲示するか、又は、弊社が適当と判断するその他の合理的な方法により、適宜会員に告知するものとします。 
３．ＦＣＳネットサービスを利用するために必要な電話や通信機器等の設備費用、及びＦＣＳネットサービスへのアクセスに伴って発生した電話料金等は、会員がこれを負担するものとします。 
４．弊社は、ＦＣＳネットサービスの提供が中断したことを理由に料金の減額、返金は一切行わないものとします。（この条の１に関わること）

第１０条（禁止事項）
会員は、以下の行為を行わないものとします。
(1)他の会員のユーザーID及びパスワードを不正に使用する行為。
(2)コンピュータウィルス等有害なプログラムをＦＣＳネットサービスに関連して使用し若しくは提供する行為。
(3)弊社、他の会員、その他の第三者又はＦＣＳネットサービスに損害を与え、又は与えるおそれのある行為。
(4)事実に反する情報を提供する行為。
(5)ＦＣＳネットサービスを通じて提供される情報を改ざんする行為。
(6)弊社の承認なく、ＦＣＳネットサービスを通じ又はＦＣＳネットサービスに関
連して営利を目的とする活動を行う行為。
(7)他の会員や第三者を誹謗または中傷したり、名誉を傷つける行為。
(8)他の会員や第三者のプライバシーを侵害する行為。
(9)公序良俗に反する行為あるいは公序良俗に反する情報を他の会員に提供する行為。
(10)ＦＣＳネットサービスの運営を妨げるような行為。
(11)その他、法令に違反する行為、又は違反するおそれのある行為。
(12)その他、弊社が不適切と判断する行為。

第１１条（著作権等）
会員は、事前に弊社又は著作権者の特段の許諾がある場合を除き、原則として、ＦＣＳネットサービスを通 じて提供される著作物を、著作権法で定める私的使用の範囲内でのみ利用するものとします。

第１２条（運営の中止中断） 
１．弊社は、以下の場合には、ＦＣＳネットサービスの運営を中止中断できるものとします。
(1)弊社のＦＣＳネットサービス用設備の保守を実施する場合。
(2)天災、停電、戦争等の不可抗力によりＦＣＳネットサービスの提供ができなくなった場合。
(3)その他弊社がＦＣＳネットの運営上一時的な中断が必要と判断した場合。 
２．弊社は、前項の規定によりＦＣＳネットの運営を中止中断するときは、あらかじめその旨を会員に通 知します。但し、緊急やむを得ない場合は、この限りではありません。

第１３条（ＦＣＳネットの廃止）
弊社は、営業上その他の理由により、ＦＣＳネットを廃止することがあり、その場合は、廃止が施行される日から少なくとも２ヶ月前までにＦＣＳネットを通 じて会員に連絡するものとします。

第１４条（解約、会員資格の取り消し） 
１．会員が以下の各号のいずれかにでも該当する場合は、弊社は、直ちに会員との会員契約を解約することができるものとします。
(1)第１０条（禁止事項）に該当すると弊社が判断した場合。
(2)虚偽の内容に基づいて会員契約の申込をしたことが判明した場合。
(3)料金支払いの遅延または不履行があった場合。
(4)登録時の組織から他の組織へ移動・移籍した場合。
(5)その他本規約に違反した場合。
(6)その他会員として不適切と弊社が判断した場合。 
２．前項において、会員契約が解約された場合、解約の日までに発生した貨物のブッキングにより発生する輸送料金、その他ＦＣＳネットサービスの利用に関連して弊社に対して支払うべき全ての金員を、直ちに、全額一括して、弊社に支払うものとします。

第１５条（退会）
会員は、退会しようとする場合には、その旨を明記した届出書を、書面またはＥ－ＭＡＩＬにて弊社に提出しなければならないものとします。

第１６条（弊社の免責） 
１．弊社は、理由の如何を問わず、ＦＣＳネットサービスの提供が遅延し又は中断したことに起因して会員又は第三者が被った損害について、一切の責任を負わないものとします。 
２．弊社は、会員がＦＣＳネットサービスの利用を通じて得た情報等の正確性、特定の目的への適合性等について、一切保証責任を負わないものとします。また、これらの情報等に起因して生じた損害に対しても、一切の責任を負わないものとします。 ＦＣＳネットサービスを通じて提供される情報に関し、会員と他の会員あるいは第三者と紛争が生じた場合は、会員は、自己の費用と責任においてこれを解決するものとし、弊社に損害を与えないものとします。

第１７条（機密保持）
弊社は、ＦＣＳネットサービスに関して弊社が知り得たパスワードをはじめとする会員の秘密情報を、第三者に漏洩しないものとします。

第１８条（管轄裁判所）
ＦＣＳネットサービスの利用に関して、弊社と会員との間に、訴訟の必要が生じた場合は、大阪地方裁判所を第一審の専属管轄裁判所とします。

付則 この規約は平成25年4月1日から実施します。`;

export const bookingTermsOfUseJa = `
D2Dブッキング利用規約

この利用規約（以下、「本規約」といいます）は、エフシースタンダードロジックス株式会社（以下、「当社」といいます）がこのウェブサイト上で提供するサービス（以下、「本サービス」といいます）の利用条件を定めるものです。ユーザーの皆さま（以下、「ユーザー」といいます。）には、本規約に従って本サービスをご利用いただきます。

第1条（適用）
1.本規約は、ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。
2.当社は本サービスに関し、本規約のほか、ご利用にあたってのルール等、各種の定め（以下、「個別規定」といいます）をすることがあります。これら個別規定はその名称のいかんに関わらず、本規約の一部を構成するものとします。

第2条（予約申し込み）
1.本サービスにおいては、利用希望者が本規約に同意の上、当社の定める方法によって予約を申し込み、当社がこれを承認することによって、予約が完了するものとします。
2.当社は、予約の申し込み者に、別項にて記載する禁止事項に抵触する行為があったと判断した場合、予約を承認しないことがあり、その理由については一切の開示義務を負わないものとします。 

第3条（予約番号の管理）
1.ユーザーは、自己の責任において、本サービスの予約番号を適切に管理するものとします。
2.ユーザーは、いかなる場合にも、予約番号を第三者に譲渡または貸与し、もしくは第三者と共用することはできません。
3.予約番号が第三者によって使用されたことによって生じた損害は、当社に故意又は重大な過失がある場合を除き、当社は一切の責任を負わないものとします。

第4条（利用料金および支払方法）
1. 会員登録及び本サービスの利用に関する費用は原則的に無料とします。ただし、今後新たなサービスの展開をする場合、そのサービスの内容によっては、またそのサービスに限定しての料金を定めることがあります。
2. 本サービスの提供が中断したことを理由として、有料で提供されるサービス料金の減額、返金は一切おこなわないものとします。

第5条（禁止事項）
1ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。
a 他の会員のユーザーID及びパスワードの不正使用
b コンピュータウィルス等有害なプログラムの使用
c 当社、他の会員、その他の第三者又は本サービスに損害を与える、或いは与えるおそれのある行為
d 本サービスを通じて提供される情報を改ざんする行為
e 当社の承認なき本サービスを通じた、或いは本サービスに関連した営利目的の活動
f 本サービスの運営を妨げるような行為
g 故意、過失を問わず、法令に違反する行為、又は違反するおそれのある行為
h その他、当社が不適切と判断する行為
2以下のものについては、関税法でその輸入が禁止されています（関税法第69条の11）。これらの禁止されているものを輸入した場合には、関税法等で処罰されることとなります（関税法の罰条）。
a 麻薬、向精神薬、大麻、あへん、けしがら、覚せい剤、あへん吸煙具
b 指定薬物（医療等の用途に供するために輸入するものを除く。）
c けん銃、小銃、機関銃、砲、これらの銃砲弾及びけん銃部品
d 爆発物
e 火薬類
f 化学兵器の禁止及び特定物質の規制等に関する法律第2条第3項に規定する特定物質
g 感染症の予防及び感染症の患者に対する医療に関する法律第6条第20項に規定する一種病原体等及び同条第21項に規定する二種病原体等
h 貨幣、紙幣、銀行券、印紙、郵便切手又は有価証券の偽造品、変造品、模造品及び偽造カード（生カードを含む）
i 公安又は風俗を害すべき書籍、図画、彫刻物その他の物品
j 児童ポルノ
k 特許権、実用新案権、意匠権、商標権、著作権、著作隣接権、回路配置利用権又は育成者権を侵害する物品
l 不正競争防止法第２条第１項第１号から第３号まで又は第１０号から第１２号までに掲げる行為を組成する物品
（注）上記のほかに医薬品、医療機器等の品質、有効性及び安全性の確保等に関する法律、植物防疫法、家畜伝染病予防法などにおいても輸入が禁止されているものがあります。また、違法ではないと称して販売されているハーブやアロマオイル、バスソルトなどの商品の中には、「麻薬」や「指定薬物」にあたり、輸入が禁止されているものがありますので、ご注意ください。

第6条（利用制限）
1当社は、ユーザーは本サービス利用時、下記にあるD2Dの利用制限について、ご了解いただいた上でのお申し込みであると判断いたします。
<span>a アマゾンや楽天への納品をご希望の場合には、必ず予約依頼の前にその旨ご連絡ください。</span>
b 長尺もの、大型貨物、重重量貨物、１個の重量が2,500KGSを超える重量の重いもの、一辺の長さが4mを超える長尺のものは各地倉庫の設備が違うため、当社営業担当、カスタマーサービス、もしくは各地代理店との事前確認が必要です。予約依頼の前にご連絡ください。
c 高価な商品の場合、必ず<span>予約依頼の前</span>にその旨をご連絡ください。
d 割れ物、温度管理を必要とする貨物、貴重品や高額な商品の場合、必ず<span>予約依頼の前</span>にその旨を連絡ください。輸送時に固定、緩衝材の使用など、輸送方法に配慮・工夫を施し、<span>緩衝材や固定の材料費をオプションサービスとしてご請求する事がございます。</span>
e 商品の特殊な形状や上積み禁止のお荷物の場合、別途料金をご請求することがございます。
f 電池を内蔵している商品をご依頼の際は、必ず事前にご連絡ください。
g 危険品は、基本的にお取り扱いできません。

第7条（本サービスの提供の停止等）
1当社は、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。 
a 本サービスにかかるコンピュータシステムの保守点検または更新を行う場合
b 地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合
c コンピュータまたは通信回線等が事故により停止した場合
d その他、当社が本サービスの提供が困難と判断した場合
e 当社は、本サービスの提供の停止または中断により、ユーザーまたは第三者が被ったいかなる不利益または損害についても、一切の責任を負わないものとします。

第8条（保証の否認および免責事項）
当社は、本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます）がないことを明示的にも黙示的にも保証しておりません。
2当社は、本サービスに起因してユーザー間またはユーザーと第三者に生じたあらゆる損害について一切の責任を負いません。また、当社は、本サービスの提供、提供の中断、提供中の事故などによって、直接的または間接的に生じたお客様またはそれ以外の第三者の損害について、その内容、方法の如何に関わらず賠償の責任を負いません。また、お客様は本サービス関連する損害賠償請求などの訴訟に当社を引き込まないことに同意するものとします。お客様が本規約に反した行為、または不正もしくは不正アクセスなど違法な行為によって当社に損害を与えた場合、当社は損害賠償を請求できるものとします。

第9条（利用規約の変更）
当社は、必要と判断した場合には、ユーザーに通知することなくいつでも本規約を変更することができるものとします。なお、本規約の変更後、本サービスの利用を開始した場合には、当該ユーザーは変更後の規約に同意したものとみなします。

第10条（個人情報の取扱い）
当社は、本サービスの利用によって取得する個人情報については、当社「プライバシーポリシー」に従い適切に取り扱うものとします。

第11条（通知または連絡）
ユーザーと当社との間の通知または連絡は、当社の定める方法によって行うものとします。当社は、ユーザーから、当社が別途定める方式に従った変更届け出がない限り、現在登録されている連絡先が有効なものとみなして当該連絡先へ通知または連絡を行い、これらは発信時にユーザーへ到達したものとみなします。

第12条（準拠法・裁判管轄）
1本規約の解釈にあたっては、日本法を準拠法とします。
2本サービスに関して紛争が生じた場合には，当社の本店所在地を管轄する裁判所を専属的合意管轄とします。


付則この規約は令和３年12月1日から実施します。 
`;
